import { useTranslation } from "react-i18next";
import { BoldText, CruiseSubHeader, CruiseWrapper, Description, ListItem, StyledList } from "../Content/styled";
import { StaggeredContainer, StaggeredItem } from "../animations/staggeredFadeIn";
import FundingBanner from "./FundingBanner";
import { FundingSection, FundingContent } from "./styled";

const FundingInfo = () => {
    const { t } = useTranslation("boats");

    const operationItems = t("sections.funding.operation.items", {
        returnObjects: true,
    });

    const financialItems = t("sections.funding.financial.items", {
        returnObjects: true,
    });

    const renderList = (items) => (
        <StyledList>
            {items.map((item, idx) => (
                <ListItem key={idx}>
                    <BoldText>{item.label} </BoldText>
                    {item.text}
                </ListItem>
            ))}
        </StyledList>
    );

    return (
        <FundingSection>
            <FundingContent>
                <CruiseWrapper>
                    <StaggeredContainer>
                        <StaggeredItem>
                            <CruiseSubHeader>
                                {t("sections.funding.title")}
                            </CruiseSubHeader>
                        </StaggeredItem>

                        <StaggeredItem>
                            <Description>
                                {t("sections.funding.intro")}
                            </Description>
                        </StaggeredItem>

                        <StaggeredItem>
                            {renderList(operationItems)}
                        </StaggeredItem>

                        <StaggeredItem>
                            <CruiseSubHeader>
                                {t("sections.funding.financial.title")}
                            </CruiseSubHeader>
                        </StaggeredItem>

                        <StaggeredItem>
                            {renderList(financialItems)}
                        </StaggeredItem>
                    </StaggeredContainer>
                </CruiseWrapper>
            </FundingContent>

            <FundingBanner />
        </FundingSection>
    );
};

export default FundingInfo;